module.exports = __webpack_public_path__ + "static/media/samsung-aife-2019-battery.b19326d4.mp4";